import { render, staticRenderFns } from "./HeaderActionButtons.vue?vue&type=template&id=03ca9cc4"
import script from "./HeaderActionButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ca9cc4')) {
      api.createRecord('03ca9cc4', component.options)
    } else {
      api.reload('03ca9cc4', component.options)
    }
    module.hot.accept("./HeaderActionButtons.vue?vue&type=template&id=03ca9cc4", function () {
      api.rerender('03ca9cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderActionButtons.vue"
export default component.exports